<template>
	<div class="omapi-section omapi-section__about-us" id="omapi-section__about-us">
		<core-loading v-if="isLoading"/>
		<div v-else class="omapi-card__flex">
			<common-card class="omapi-section omapi-section__details">
				<div class='omapi-multi-column omapi-flex omapi-flex-row omapi-flex-row__1080'>
					<div class='omapi-multi-column__primary'>
						<p class="focus">When we started OptinMonster, we had one goal in mind: to help small businesses grow and compete with the big guys.</p>
						<p>We were tired of seeing only the companies with the deepest pockets get access to quality lead generation software to grow their list, leads and sales. So we set out to create a best-in-class tool at a price even small businesses could afford.</p>
						<p>Over 1 BILLION people see a website serving OptinMonster campaigns each month. From the blogger just getting started or small independent local businesses, to growing eCommerce stores and even Fortune 500 companies… we help the most reputable brands online make targeted offers to the right person, at the right time.</p>
						<p>But don’t take our word for it! We have over 240 <span class="stars">★★★★★</span> reviews at wordpress.org and almost <a :href="$urls.marketing('testimonials/?utm_source=WordPress&utm_campaign=Plugin&utm_medium=AboutUs')" target="_blank" rel="noopener">100 case studies</a> from real businesses like yours sharing their real results. We were included in  HelpScout's 2020 Customer Service Awards, nailing a spot in the top 15 amongst all of the thousands of B2B companies that use HelpScout to provide support. Our Customer Success team has an average time to first response of just over an hour, and an average Happiness rating of 90%. Our experienced Customer Success Specialists even offer to build a personalized campaign FOR FREE for every OptinMonster customer to get them started on the right foot.</p>
						<p>Thank you for the opportunity to help you win and win more often!</p>
					</div>
					<div class='omapi-multi-column__secondary'>
						<img src="../../assets/images/om-team.jpg" alt="The OptinMonster Team">
						<caption>The OptinMonster Team</caption>
					</div>
				</div>
			</common-card>
			<common-card size="half"
				contentClass="omapi-card__border omapi-plugins"
				v-for="plugin in plugins"
				:key="plugin.id"
				>
				<div class='omapi-multi-column omapi-flex omapi-flex-row'>
					<div class='omapi-multi-column__secondary omapi-icon-wrapper omapi-icon-wrapper__left'>
						<img :src="plugin.icon" :alt="plugin.name">
					</div>
					<div class='omapi-multi-column__primary'>
						<h3 class='omapi-multi-column__title'>{{ plugin.name }}</h3>
						<div class='omapi-multi-column__text'>{{ plugin.desc }}</div>
					</div>
				</div>
				<template v-slot:footer>
					<div class='omapi-status'>
						<span class='omapi-multi-column__meta-attr'>Status: </span>
						<span class='omapi-multi-column__meta-value'
							:class="[
								'Active' === plugin.status ? 'omapi-multi-column__meta-green' : '',
								'Inactive' === plugin.status ? 'omapi-multi-column__meta-red' : ''
							]"
						>
							{{ plugin.status }}
						</span>
					</div>
					<form @submit.prevent="submit(plugin)" class="omapi-plugins__form">
						<core-button
							v-if="! plugin.installed"
							class="button-install"
							type="secondary"
							color="blue"
							buttonType="submit"
						>{{ installButtonText(plugin) }}</core-button>
						<core-button
							v-else-if="! plugin.active"
							class="button-activate"
							type="secondary"
							color="blue"
							buttonType="submit"
						>{{ activateButtonText(plugin) }}</core-button>
					</form>
				</template>
			</common-card>
		</div>
	</div>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
	data () {
		return {
			workingPlugins : [],
		}
	},
	mounted () {
		this.fetchPlugins()
	},
	computed : {
		...mapState('plugins', [ 'plugins' ]),
		isLoading () {
			return this.$store.getters.isLoading('plugins')
		},
	},
	methods : {
		...mapActions('plugins', {
			fetchPlugins : 'fetch',
			pluginAction : 'action',
		}),
		installButtonText (plugin) {
			let text = 'Install Plugin'

			if (this.workingPlugins.includes(plugin.id)) {
				text = 'Installing...'
			}

			return text
		},
		activateButtonText (plugin) {
			let text = 'Activate Plugin'

			if (this.workingPlugins.includes(plugin.id)) {
				text = 'Activating...'
			}

			return text
		},
		handlePluginActionFailed (pluginId) {
			const index = this.workingPlugins.indexOf(pluginId)
			if (-1 < index) {
				this.workingPlugins.splice(index, 1)
			}
		},
		submit (plugin) {
			this.workingPlugins.push(plugin.id)
			this.pluginAction(plugin)
				.then(() => window.location.reload())
				.catch(() => {
					this.handlePluginActionFailed(plugin.id)
				})
		},
	},
}
</script>
